var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delayed-crossfade"},[_c('transition',{attrs:{"name":"delayed-crossfade"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }